import script from "./ProjectManageMember.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectManageMember.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectManageMember.vue?vue&type=style&index=0&id=6b59f62e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b59f62e"]])

export default __exports__